import {NgIf} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AppAuthService} from '@app/auth';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {SelectModule} from 'primeng/select';
import {ApiService} from '../../@core/utils/api.service';

@Component({
	selector: 'ngx-lang-picker',
	standalone: true,
	templateUrl: './lang-picker.component.html',
	imports: [
		SelectModule,
		FormsModule,
		TranslateModule,
		NgIf,
	],
})
export class LangPickerComponent implements OnInit {

	constructor(private authService: AppAuthService, protected translate: TranslateService, private apiService: ApiService) {
	}

	ngOnInit(): void {
		this.authService.onTokenChange().subscribe(token => {
			this.apiService.me().subscribe((response) => {
				if (response['lang']) {
					this.changeLang(response['lang'], false);
				}
			});
		});
		this.translate.addLangs(['FR', 'NL', 'PT', 'IT']);
		this.changeLang(localStorage.getItem('locale') ? localStorage.getItem('locale') : 'FR', false);
	}

	public changeLang($event: any, save = true): void {
		if (!['FR', 'NL', 'PT', 'IT'].includes($event)) {
			$event = 'FR';
			save = false;
		}
		this.translate.setDefaultLang($event);
		this.translate.use($event).subscribe(tmp => {
		});
		localStorage.setItem('locale', $event);
		if (save) {
			this.apiService.updateUserLang($event).subscribe(value => {
			});
		}
	}
}
